import React, { useState } from 'react';
import { ButtonTheme, ButtonType } from 'app/ui-components/PlayButton/PlayButton';
import { useRouter } from 'next/router';
import PlayText, { SIZE } from 'app/ui-components/typography/PlayText/PlayText';
import { Survey } from 'app/graphql/__generated__/types/contento';
import {
    Button,
    Heading,
    StyledRange,
    Form,
    Label,
    Input,
    InputWrapper,
    ButtonWrapper,
    LegendWrapper,
    Legend,
    CustomRadio,
    Byline,
} from '../UsabilityTest.styles';
import { Task } from '../models';

type Props = {
    onClick: (value: number) => void;
    onCloseSurvey: (value: string) => void;
    task: Task;
    survey: Survey;
};

const Expected = ({ onClick, onCloseSurvey, survey, task }: Props) => {
    const [difficulty, setDifficulty] = useState(null);
    const router = useRouter();

    const onValueChange = (value: number) => {
        setDifficulty(value);
    };

    const getInputs = () => {
        const inputs = [];

        for (let i = 1; i <= 7; i++) {
            inputs.push(
                <Label key={`expected-input-${i}`}>
                    {i}
                    <Input
                        checked={difficulty === i}
                        type="radio"
                        value={i}
                        onChange={() => onValueChange(i)}
                    />
                    <CustomRadio />
                </Label>
            );
        }

        return inputs;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onClick(difficulty);
        setDifficulty(null);
        router.push('/');
    };

    return (
        <>
            <Byline size={SIZE.SMALL}>Uppgift</Byline>

            <Heading>{task.heading}</Heading>
            <PlayText>Hur lätt eller svårt förväntar du dig det är att utföra uppgiften?</PlayText>
            <Form onSubmit={handleSubmit}>
                <InputWrapper>{getInputs()}</InputWrapper>

                <StyledRange />
                <LegendWrapper>
                    <Legend>Mycket svårt</Legend>
                    <Legend>Mycket lätt</Legend>
                </LegendWrapper>

                <ButtonWrapper>
                    <Button
                        buttonType={ButtonType.BUTTON}
                        theme={ButtonTheme.DEFAULT}
                        type="button"
                        onClick={() => {
                            onCloseSurvey(survey.id);
                        }}
                        cancel
                    >
                        Avbryt
                    </Button>
                    <Button
                        isDisabled={difficulty === null}
                        buttonType={ButtonType.BUTTON}
                        theme={ButtonTheme.WHITE}
                        type="submit"
                    >
                        Starta uppgiften
                    </Button>
                </ButtonWrapper>
            </Form>
        </>
    );
};

export default Expected;
